export const DEFAULT_COLOR = 'gray';
export const CORRECT_COLOR = 'green';
export const WRONG_COLOR = 'red';
export const DONT_KNOW_COLOR = 'yellow';
